import React, { useEffect, useState } from 'react';
import './organisation.css';

const Organisation = () => {
    const [logos, setLogos] = useState([]);

    useEffect(() => {
        fetch('/sample1.csv')
            .then(res => res.text())
            .then(text => {
                const lines = text.trim().split('\n');
                const headers = lines[0].split(',');
                const logoIdx = headers.indexOf('org logo');
                if (logoIdx === -1) return;
                const data = lines.slice(1)
                    .map(line => {
                        // Handle quoted commas
                        const row = [];
                        let current = '';
                        let inQuotes = false;
                        for (let i = 0; i < line.length; i++) {
                            const char = line[i];
                            if (char === '"') inQuotes = !inQuotes;
                            else if (char === ',' && !inQuotes) {
                                row.push(current);
                                current = '';
                            } else {
                                current += char;
                            }
                        }
                        row.push(current);
                        return row[logoIdx]?.replace(/^"|"$/g, '');
                    })
                    .filter(logo => logo && logo.startsWith('http'));
                setLogos([...new Set(data)]);
            });
    }, []);

    return (
        <div className="org-section">
            <h2 className="org-title">Partner Organizations for DMP 2025</h2>
            <div className="org-grid">
                {logos.map((logo, idx) => (
                    <div className="org-logo-card" key={logo + idx}>
                        <img src={logo} alt="Organization Logo" className="org-logo-img" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Organisation;